import Dexie from 'dexie';

/**
 * Base de données IndexedDB pour GroceWise.
 * Gère les magasins, rayons, templates d'articles et items de liste.
 */
class GroceWiseDB extends Dexie {
  constructor() {
    super('grocewise-db');

    this.version(1).stores({
      // Magasins
      stores: '++id, name, createdAt',
      // Rayons (index composé pour tri par magasin + ordre)
      aisles: '++id, storeId, name, order, createdAt, [storeId+order]',
      // Templates d'articles (index unique storeId+name pour l'upsert)
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      // Items de la liste active
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt',
    });

    this.version(2).stores({
      stores: '++id, name, createdAt',
      aisles: '++id, storeId, name, order, createdAt, [storeId+order]',
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt',
      // Lien magasin local ↔ liste partagée
      sharedLinks: '++id, storeId, shareCode',
    });

    this.version(3).stores({
      stores: '++id, name, createdAt',
      aisles: '++id, storeId, name, order, createdAt, [storeId+order], serverId',
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt, serverId',
      sharedLinks: '++id, storeId, shareCode',
    });

    // v4 : ajout de l'ordre personnalisé des magasins
    this.version(4).stores({
      stores: '++id, name, order, createdAt',
      aisles: '++id, storeId, name, order, createdAt, [storeId+order], serverId',
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt, serverId',
      sharedLinks: '++id, storeId, shareCode',
    }).upgrade(async (tx) => {
      // Initialiser l'ordre des magasins existants par nom alphabétique
      const stores = await tx.table('stores').toArray();
      stores.sort((a, b) => a.name.localeCompare(b.name));
      for (let i = 0; i < stores.length; i++) {
        await tx.table('stores').update(stores[i].id, { order: i });
      }
    });

    // v5 : ajout serverId aux stores pour la sync cross-device
    this.version(5).stores({
      stores: '++id, name, order, createdAt, serverId',
      aisles: '++id, storeId, name, order, createdAt, [storeId+order], serverId',
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt, serverId',
      sharedLinks: '++id, storeId, shareCode',
    });

    // v6 : partage par compte — suppression sharedLinks, ajout role/shareCode sur stores
    this.version(6).stores({
      stores: '++id, name, order, createdAt, serverId',
      aisles: '++id, storeId, name, order, createdAt, [storeId+order], serverId',
      articleTemplates: '++id, name, storeId, aisleId, createdAt, &[storeId+name]',
      listItems: '++id, storeId, name, aisleId, quantity, checked, addedAt, serverId',
    });
  }
}

/** Instance singleton de la base de données */
export const db = new GroceWiseDB();
